import {getBirthDay, getBirthMonth, getBirthYear, getFirstName, getPassword, getSurname, getUsername} from "../selectors";
import {FINISH_LOGIN_DONE, MAIN_HANDLE_PENDING_STATUS, VALIDATE_FORM_ERROR, VALIDATE_FORM_SUCCESS} from "../reducers";
import {API_FE_DOMAIN, API_FE_VALIDATE_FORM} from "../constants";
import { put, call, select } from 'redux-saga/effects';
import axios from "axios";

export default function* validateFormSaga(action) {
    try {
        const username = yield select(getUsername);
        const password = yield select(getPassword);
        const firstName = yield select(getFirstName);
        const lastName = yield select(getSurname);
        const day = yield select(getBirthDay);
        const month = yield select(getBirthMonth);
        const year = yield select(getBirthYear);

        yield put({
            type: MAIN_HANDLE_PENDING_STATUS,
            payload: { updatedField: action.payload.updatedField, isLoading: true },
        });

        const result = yield call(() => axios.post(
            API_FE_DOMAIN + API_FE_VALIDATE_FORM,
            {
                username,
                firstName,
                lastName,
                day: day !== '-' ? day : '',
                month: month !== '-' ? month : '',
                year: year !== '-' ? year : '',
                password,
                source: 'shop'
            },
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }
        ));

        yield put({
            type: MAIN_HANDLE_PENDING_STATUS,
            payload: { updatedField: action.payload.updatedField, isLoading: false },
        });

        const response = result.data;

        if (response.status === 1) {
            yield put({
                type: VALIDATE_FORM_SUCCESS,
                payload: {
                    updatedField: action.payload.updatedField,
                },
            });

            yield put({ type: FINISH_LOGIN_DONE, payload: '' });
        } else {
            yield put({
                type: VALIDATE_FORM_ERROR,
                payload: {
                    error: response.error,
                    updatedField: action.payload.updatedField,
                    validationErrors: response.data != null ? response.data.validationErrors : null
                },
            });
        }
    } catch (e) {
        console.error(e);
    }
}
